export const ExclusiveEmptyCard = () => {
  return (
    <div className="overflow-hidden relative rounded content-center border border-white/[10%] grid place-items-center aspect-video">
      <h2 className="text-center">No Exclusives unlocked yet</h2>
    </div>
  )
}
